import { render } from "./Grade.vue?vue&type=template&id=da920308&scoped=true"
import script from "./Grade.vue?vue&type=script&lang=js"
export * from "./Grade.vue?vue&type=script&lang=js"

import "./Grade.vue?vue&type=style&index=0&id=da920308&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da920308"]])

export default __exports__